import { useCalendarGridStore } from '../../store/calendar-grid.store';
import { GroupBody } from './group-body';
import { GroupHeader } from './group-header';
import { GroupHourLines } from './group-hour-lines';
import { TodayTimeIndicator } from './time-indicator/today-time-indicator';

export const ColumnGroupSections = () => {
  const { groupIds } = useCalendarGridStore(['groupIds']);

  if (!groupIds.length) return null;

  return groupIds.map((groupId, index) => <ColumnGroupSection key={groupId} groupId={groupId} groupIndex={index} />);
};

const ColumnGroupSection = ({ groupId, groupIndex }: { groupId: string; groupIndex: number }) => {
  const { hasMultipleGroups, headerType, columnBodyVariant, localColumnOrderByGroup } = useCalendarGridStore([
    'hasMultipleGroups',
    'headerType',
    'columnBodyVariant',
    'localColumnOrderByGroup',
  ]);
  const groupInfo = useCalendarGridStore((s) => s.groupsById[groupId]);
  const columnCount = groupInfo?.columnIds?.length;

  if (!columnCount) return null;

  // During drag, use the local (in-progress) column order so both header and body reorder live
  const columnIds = localColumnOrderByGroup[groupId] ?? groupInfo.columnIds;

  const startColumn = groupIndex + groupInfo.groupOffset + 2; // +1 for time labels, +1 for 1-based grid
  const gridColumn = `${startColumn} / span ${columnCount}`;

  return (
    <>
      <GroupHeader
        gridColumn={gridColumn}
        groupInfo={groupInfo}
        isGroupHeaderVisible={hasMultipleGroups}
        headerType={headerType}
        columnIds={columnIds}
      />
      <GroupBody
        isFirstGroup={groupIndex === 0}
        startColumn={startColumn}
        groupId={groupId}
        columnIds={columnIds}
        columnBodyVariant={columnBodyVariant}
      />
      <GroupHourLines gridColumn={gridColumn} />
      <TodayTimeIndicator gridColumn={gridColumn} timezone={groupInfo.timezone} />
    </>
  );
};
